import React from "react";
// import { Link } from "react-router-dom";

export default function HoteleriaBariloche({ bgColor }) {
  return (
    <>
      <section
        id="hoteleria"
        className={`contact-us ptb-100 ${bgColor ? "gray-light-bg" : ""}`}
      >
        <section className="team-member-section ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7 col-md-8">
                <div className="section-heading text-center mb-4">
                  <h2>HOTELERIA EXCLUSIVA</h2>
                  <h3>All inclusive</h3>
                  <p className="lead">
                    ¡Prepárate para el viaje de egresados de tus sueños! Nuestra
                    hoteleria exclusiva all inclusive, con spa, jacuzzi, sala de
                    juegos, gimnasio y vistas impresionantes al Lago Nahuel
                    Huapi que te dejarán recuerdos imborrables!
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/bariloche/hoteleria/Bariloche-hotel-interlaken.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">Hotel Interlaken</h5>
                    <h6>Bariloche Centro</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                      {/* <li className="list-inline-item">
                        <Link to="https://www.facebook.com/hotelgenovabc">
                          <span className="ti-facebook"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link to="https://www.instagram.com/hotelgenovabc/">
                          <span className="ti-instagram"></span>
                        </Link>
                      </li> */}
                    </ul>
                    <a
                      href="https://www.hotelinterlaken.com.ar/"
                      target="_blank"
                      rel="noreferrer"
                      className="btn app-store-btn"
                    >
                      Ver hotel
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/bariloche/hoteleria/Bariloche-hotel-Crans.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">Hotel Crans Montana</h5>
                    <h6>Bariloche Centro</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                      {/* <li className="list-inline-item">
                        <Link to="http://facebook.com/hmhotelbc">
                          <span className="ti-facebook"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link to="http://instagram.com/hmhotelbc">
                          <span className="ti-instagram"></span>
                        </Link>
                      </li> */}
                    </ul>
                    <a
                      href="https://www.hotelcransmontana.com.ar/"
                      target="_blank"
                      rel="noreferrer"
                      className="btn app-store-btn"
                    >
                      Ver hotel
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/bariloche/hoteleria/Bariloche-hotel-lagosAndinos.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">Hotel Lagos Andinos</h5>
                    <h6>Bariloche Centro</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                      {/* <li className="list-inline-item">
                        <Link to="http://facebook.com/hmhotelbc">
                          <span className="ti-facebook"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link to="http://instagram.com/hmhotelbc">
                          <span className="ti-instagram"></span>
                        </Link>
                      </li> */}
                    </ul>
                    <a
                      href="https://www.lagosandinos.com.ar/"
                      target="_blank"
                      rel="noreferrer"
                      className="btn app-store-btn"
                    >
                      Ver hotel
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
